<div>
  @if (!validateQR && isAdmin) {
    <div>
      <!-- Nav/Tab section  -->
      <ul class="nav" [ngClass]="isAdmin ? 'nav-tabs' : ''" id="checkpointTab">
        <li class="nav-item" (click)="changeTab(tabNames.tab1)">
          <a
            class="nav-link"
            [ngClass]="selectedTab === tabNames.tab1 ? 'active' : ''"
            >{{ tabNames.tab1 }}</a
          >
        </li>
        <!--QR Code section-->
        <li
          class="nav-item"
          (click)="changeTab(tabNames.tab2)"
          id="qrCheckpointTab"
        >
          <a
            class="nav-link"
            [ngClass]="selectedTab === tabNames.tab2 ? 'active' : ''"
            >{{ tabNames.tab2 }}</a
          >
        </li>
        <li
          class="nav-item"
          (click)="changeTab(tabNames.tab3)"
          id="missedCheckpointTab"
        >
          <a
            class="nav-link"
            [ngClass]="selectedTab === tabNames.tab3 ? 'active' : ''"
            >{{ tabNames.tab3 }}</a
          >
        </li>
      </ul>
    </div>
  }
  <!-- Tab Content starts -->
  <!-- Checkpoint Tab -->
  <div class="tab-content mt-2">
    @if (selectedTab === tabNames.tab1) {
      <div class="tab-pane" [class.active]="selectedTab === tabNames.tab1">
        <div class="d-flex">
          <div [ngClass]="screenWidth > splitScreenPx ? 'w-50' : 'w-100'">
            <div class="d-flex gap-2 mb-2">
              @if (totalCheckpointCount > 0 && !validateQR) {
                <div class="flex-grow-1">
                  <gtapp-auto-complete
                    [data]="checkpointDropDownList"
                    placeHolder="Search Checkpoints"
                    searchKeyword="company_name"
                    [itemTemplate]="checkpointTemplate"
                    [initialValue]="checkpointSearchString"
                    (inputChanged)="onCheckpointLookup($event)"
                    (selected)="onCheckPointClick($event)"
                    (submitted)="
                      clearValues();
                      checkpointSearchString = $event;
                      getCheckpointListData()
                    "
                  >
                  </gtapp-auto-complete>
                  <ng-template #checkpointTemplate let-item>
                    <div>
                      @if (item?.qr_code) {
                        <div class="float-end">
                          @if (item?.is_nfc_code) {
                            <img
                              src="assets/images/NFC_logo.avif"
                              alt=""
                              width="26"
                              class="mb-0 pb-0 bg-white"
                            />
                          } @else {
                            <img
                              src="assets/images/qr-code-logo.avif"
                              alt=""
                              width="26"
                              class="mb-0 pb-0"
                            />
                          }
                        </div>
                      }
                      <div class="fs-5">{{ item?.name }}</div>
                      <div>
                        @if (item?.site_name) {
                          {{ item?.site_name }} [ {{ item?.company }}]
                        } @else {
                          {{ item?.company }}
                        }
                      </div>
                      <div class="small-font text-secondary">
                        {{ item?.partial_address }}
                      </div>
                    </div>
                  </ng-template>
                </div>
              }
              <div class="d-flex gap-2">
                @if (isAdmin && !validateQR) {
                  <button
                    class="btn btn-primary"
                    id="addCheckpoint"
                    (click)="addCheckpoints()"
                  >
                    + Add Checkpoint
                  </button>
                }
                @if (qrToBeValidated) {
                  <button
                    class="btn"
                    [ngClass]="
                      validateQR ? ' btn-outline-primary' : ' btn-danger'
                    "
                    (click)="validateCheckpoints()"
                  >
                    {{ validateQR ? "Clear Filter" : "Validate Checkpoints" }}
                  </button>
                }
              </div>
            </div>

            @if (validateQR) {
              <div class="fw-bold text-center my-3" role="alert">
                Checkpoints Requiring Validation
              </div>
            }

            <gtapp-gt-custom-table
              [deskTopTableData]="
                checkpointPaginationData[pageNumCheckpoints] || []
              "
              [desktopTableDetails]="checkPointDetailsTableView"
              [tableStyle]="tableStyle"
              [otherParams]="otherParamsCheckpoints"
              (sortColumn)="sortColumnCheckpoint($event)"
              (searchColumn)="searchColumnCheckpoint($event)"
              (rowClick)="onCheckPointClick($event)"
              (paginationChange)="onChangePaginationCheckpoint($event)"
            ></gtapp-gt-custom-table>
          </div>
          @if (selectedCp?.id) {
            <div class="flex-grow-1 p-2">
              @if (selectedCp?.latitude && selectedCp?.longitude) {
                <gtapp-map-leaflet
                  [latLon]="{
                    lat: selectedCp?.latitude,
                    lon: selectedCp?.longitude,
                    geoFenceRadius: selectedCp?.min_distance,
                  }"
                  [mapId]="'checkpointLocation'"
                ></gtapp-map-leaflet>
                @if (selectedCp?.partial_address) {
                  <div
                    class="d-flex gap-1 flex-column justify-content-center align-items-center my-2"
                  >
                    <div class="d-flex gap-2">
                      <div class="fs-5">{{ selectedCp?.name }}</div>
                      @if (selectedCp?.qr_code) {
                        <div>
                          @if (selectedCp?.is_nfc_code) {
                            <img
                              src="assets/images/NFC_logo.avif"
                              alt=""
                              width="20"
                              class="mb-0 pb-0 bg-white"
                            />
                          } @else {
                            <img
                              src="assets/images/qr-code-logo.avif"
                              alt=""
                              width="20"
                              class="mb-0 pb-0"
                            />
                          }
                        </div>
                      }
                    </div>

                    <div>
                      @if (selectedCp?.site_name) {
                        {{ selectedCp?.site_name }} [ {{ selectedCp?.company }}]
                      } @else {
                        {{ selectedCp?.company }}
                      }
                    </div>
                    <div class="small-font text-secondary">
                      {{ selectedCp?.partial_address }}
                    </div>
                  </div>
                }
              }
              <div class="d-flex flex-wrap gap-2 pt-4">
                <div class="flex-grow-1">
                  <button
                    class="btn btn-outline-primary btn-md w-100"
                    (click)="onCheckpointRedirect(selectedCp)"
                  >
                    Edit Checkpoint
                  </button>
                </div>
                <div class="flex-grow-1">
                  <button
                    class="btn btn-secondary btn-md w-100"
                    (click)="redirectCompanyORSite(selectedCp)"
                  >
                    {{ selectedCp?.site_id ? " View Site " : " View Client " }}
                  </button>
                </div>
                @if (isAdmin) {
                  <div class="flex-grow-1">
                    <!-- Only allow administrators to delete checkpoints -->
                    <button
                      class="btn btn-danger btn-md w-100"
                      (click)="deleteCheckPoint(selectedCp)"
                    >
                      Delete
                    </button>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (selectedTab === tabNames.tab2) {
      <div class="tab-pane" [class.active]="selectedTab === tabNames.tab2">
        <gtapp-generate-qr></gtapp-generate-qr>
      </div>
    }
    @if (selectedTab === tabNames.tab3) {
      <div class="tab-pane" [class.active]="selectedTab === tabNames.tab3">
        @if (largeView) {
          <gtapp-gt-custom-table
            [deskTopTableData]="missedCheckpointData"
            [desktopTableDetails]="tableDetailMissedCheckpoint"
            [otherParams]="otherParamsMissedCheckpoint"
            (paginationChange)="onChangePaginationMissedCheckpoint($event)"
            (searchColumn)="searchColumnMissedCheckpoint($event)"
            (sortColumn)="sortColumnMissedCheckpoint($event)"
            (paginationChange)="onChangePaginationMissedCheckpoint($event)"
            (rowClick)="redirectToPatrol($event)"
          ></gtapp-gt-custom-table>
        } @else {
          <gtapp-infinite-list
            [mobileCardBackendData]="infiniteMissedCheckpointDataList"
            [mobileCardDetails]="mobileDetailMissedCheckpoint"
            [totalRows]="totalRowsMissedCheckpoint"
            (loadMoreData)="
              previousMissedCheckpoint =
                previousMissedCheckpoint + pageSizeMissedCheckpoint;
              getMissedCheckpointData()
            "
            (rowClick)="redirectToPatrol($event)"
            (sortColumn)="sortColumnMissedCheckpoint($event)"
            (searchColumn)="searchColumnMissedCheckpoint($event)"
          ></gtapp-infinite-list>
        }
      </div>
    }
  </div>
</div>
